import { createContext, useState, useContext, useEffect } from "react";
import useSections from "../utilities/ny-times-sections";

const SectionsContext = createContext();

export const SectionsProvider = ({ children }) => {
  const [navSections, setNavSections] = useState([]);
  const { sections, loading, error } = useSections();

  useEffect(() => {
    if (sections.length > 0) {
      setNavSections(sections);
    }
  }, [sections]);

  return (
    <SectionsContext.Provider value={{ navSections, loading, error }}>
      {children}
    </SectionsContext.Provider>
  );
};

export const useSectionsContext = () => {
  const context = useContext(SectionsContext);
  if (!context) {
    throw new Error("useSectionsContext must be used within a SectionsProvider");
  }
  return context;
};

export default SectionsContext;
